import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';

const RadioGroupAnt = Radio.Group;

function RadioGroup(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <RadioGroupAnt {...props}>
      {props.data.map((item, index) => (
        <Radio
          key={index}
          value={item.value}
        >
          {item.name}
        </Radio>
      ))}
    </RadioGroupAnt>
  );
}

RadioGroup.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.any)
};

RadioGroup.defaultProps = {
  checked: false,
  className: '',
  data: []
};

export default RadioGroup;
